import * as React from "react";
import CookieBanner from "../components/legal/cookie_banner";

// router
import { BrowserRouter } from "react-router-dom";

// auth and pages
// import { ComingSoon } from '../screens';
import AnimatedRoute from "./AnimatedRoute";

const MainNavigation: React.FC = () => {
  return (
    <BrowserRouter>
      <AnimatedRoute />
      <CookieBanner />
    </BrowserRouter>
  );
};

export default MainNavigation;
